module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAABoAQMAAAD2NSOSAAAAA1BMVEXV2t2vjUn9AAAAC0lEQVR4AWMYZgAAANAAAR9SDUwAAAAASUVORK5CYII="